import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "@/contexts/AppContext";
import { Problem } from "@/models/summary";

interface ProblemCardStateHookProps {
  problem: Problem;
  totalCaseCount: number;
}

export const useProblemCardState = ({
  problem,
  totalCaseCount,
}: ProblemCardStateHookProps) => {
  const { t } = useTranslation("voiceek_ui");
  const { isComparisionMode } = useContext(AppContext);
  const [isClosed, setIsClosed] = useState(false);

  const progressPercentage = totalCaseCount > 0 ? (problem.caseCount / totalCaseCount) * 100 : 0;
  const progressPercentageFloor = Math.floor(progressPercentage * 10) / 10;
  const referenceText = t("analysis.problem.referenceVoc", { count: problem.caseCount });

  useEffect(() => {
    if (isComparisionMode) {
      setIsClosed(true);
    } else {
      setIsClosed(false);
    }
  }, [isComparisionMode]);

  return {
    isClosed,
    setIsClosed,
    progressPercentageFloor,
    referenceText,
    isComparisionMode,
  };
};
